import './callPage.css';
import { useState, useEffect, useRef } from "react";
import { useParams } from 'react-router-dom';
import axios from 'axios';
import BASE_URL from '../../config';
import { FiRotateCw } from 'react-icons/fi';

function SharedCallPage() {
  const { contactid } = useParams();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [contactData, setContactData] = useState(null);
  const [rotation, setRotation] = useState(0);
  const [activeSession, setActiveSession] = useState(null);
  const [isCallActive, setIsCallActive] = useState(false);
  const videoRef = useRef(null);
  const [zoom, setZoom] = useState(1);

  const handleRotate = () => {
    const newRotation = (rotation + 90) % 360;
    setRotation(newRotation);
  };

  const handleZoom = (delta) => {
    setZoom((prev) => {
      const newZoom = Math.min(Math.max(prev + delta, 1), 3);
      return newZoom;
    });
  };

  useEffect(() => {
    if (videoRef.current) {
      videoRef.current.style.transform = `scale(${zoom})`;
    }
  }, [zoom]);

  useEffect(() => {
    const fetchSharedContact = async () => {
      try {
        const response = await axios.get(`${BASE_URL}/api/contact/shared-call/${contactid}/`);
        setContactData(response.data);
        setLoading(false);
      } catch (err) {
        console.error('Error fetching shared contact:', err);
        setError('Failed to load shared contact. Please check the link and try again.');
        setLoading(false);
      }
    };

    fetchSharedContact();
  }, [contactid]);

  useEffect(() => {
    if (!contactData || !window.SIP) return;

    const accountData = {
      Display: contactData.pbxusername,
      User: contactData.pbxusername,
      Pass: contactData.pbxpassword,
      WSServer: 'wss://pbx.mavistech.cloud:8089/ws',
      Realm: 'pbx.mavistech.cloud',
    };

    localStorage.setItem("sipCredentials", JSON.stringify(accountData));

    window.$(document).ready(function() {
      if (typeof(accountData) === 'undefined') {
        return;
      }

      window.ctxSip = {
        config: {
          password: accountData.Pass,
          authorizationUser: accountData.User,
          displayName: accountData.Display,
          uri: accountData.User + '@' + accountData.Realm,
          transportOptions: {
            wsServers: accountData.WSServer,
            traceSip: true
          },
          registerOptions: {
            expires: 180
          },
          hackWssInTransport: true,
          log: {
            builtinEnabled: true,
            level: 3
          },
        },
        ringtone: document.getElementById('ringtone'),
        ringbacktone: document.getElementById('ringbacktone'),
        dtmfTone: document.getElementById('dtmfTone'),
        Sessions: [],
        callTimers: {},
        callActiveID: null,
        callVolume: 1,
        Stream: null,

        formatPhone: function(phone) {
          var num;
          if (phone.indexOf('@')) {
            num = phone.split('@')[0];
          } else {
            num = phone;
          }
          num = num.toString().replace(/[^0-9]/g, '');
          if (num.length === 10) {
            return '(' + num.substr(0, 3) + ') ' + num.substr(3, 3) + '-' + num.substr(6, 4);
          } else if (num.length === 11) {
            return '0' + num.substr(2);
          } else {
            return num;
          }
        },

        startRingTone: function() {
          try { window.ctxSip.ringtone.play(); } catch (e) { }
        },

        stopRingTone: function() {
          try { window.ctxSip.ringtone.pause(); } catch (e) { }
        },

        startRingbackTone: function() {
          try { window.ctxSip.ringbacktone.play(); } catch (e) { }
        },

        stopRingbackTone: function() {
          try { window.ctxSip.ringbacktone.pause(); } catch (e) { }
        },

        getUniqueID: function() {
          return Math.random().toString(36).substr(2, 9);
        },

        newSession: function(newSess) {
          newSess.displayName = newSess.remoteIdentity.displayName || newSess.remoteIdentity.uri.user;
          newSess.ctxid = window.ctxSip.getUniqueID();

          var status;

          if (newSess.direction === 'incoming') {
            status = "Incoming: " + newSess.displayName;
            window.ctxSip.startRingTone();
            setActiveSession(newSess);
          } else {
            status = "Trying: " + newSess.displayName;
            window.ctxSip.startRingbackTone();
          }

          window.ctxSip.logCall(newSess, 'ringing');
          window.ctxSip.setCallSessionStatus(status);

          var localVideo = document.getElementById('localVideo');
          var remoteVideo = document.getElementById('remoteVideo');

          newSess.on('trackAdded', function() {
            var pc = newSess.sessionDescriptionHandler.peerConnection;
            var remoteStream = new MediaStream();
            pc.getReceivers().forEach(function(receiver) {
              remoteStream.addTrack(receiver.track);
            });
            remoteVideo.srcObject = remoteStream;
            var playPromise = remoteVideo.play();

            if (playPromise !== undefined) {
              playPromise.then(_ => {
              }).catch(error => {
              });
            }

            setTimeout(() => {
              var localStream = new MediaStream();
              pc.getSenders().forEach(function(sender) {
                if (sender.track) {
                  localStream.addTrack(sender.track);
                }
              });

              localVideo.srcObject = localStream;
              var playPromiseLocal = localVideo.play();

              if (playPromiseLocal !== undefined) {
                playPromiseLocal.then(_ => {
                }).catch(error => {
                });
              }
            }, 500);
          });

          newSess.on('progress', function(e) {
            if (e.direction === 'outgoing') {
              window.ctxSip.setCallSessionStatus('Calling...');
            }
          });

          newSess.on('connecting', function(e) {
            if (e.direction === 'outgoing') {
              window.ctxSip.setCallSessionStatus('Connecting...');
            }
          });

          newSess.on('accepted', function(e) {
            if (window.ctxSip.callActiveID && window.ctxSip.callActiveID !== newSess.ctxid) {
              window.ctxSip.phoneHoldButtonPressed(window.ctxSip.callActiveID);
            }

            window.ctxSip.stopRingbackTone();
            window.ctxSip.stopRingTone();
            window.ctxSip.setCallSessionStatus('Answered');
            try {
              window.ctxSip.logCall(newSess, 'answered');
            } catch (logErr) {
              // Never let a call-log/UI error propagate into SIP.js's internal
              // promise chain - that would cause it to tear down the live call.
              console.error('Error logging call (non-fatal):', logErr);
            }
            window.ctxSip.callActiveID = newSess.ctxid;

            setActiveSession(newSess);
            setIsCallActive(true);
          });

          newSess.on('hold', function(e) {
            window.ctxSip.callActiveID = null;
            window.ctxSip.logCall(newSess, 'holding');
            window.ctxSip.setCallSessionStatus("Holding");
          });

          newSess.on('unhold', function(e) {
            window.ctxSip.logCall(newSess, 'resumed');
            window.ctxSip.callActiveID = newSess.ctxid;
            window.ctxSip.setCallSessionStatus("Answered");
          });

          newSess.on('muted', function(e) {
            window.ctxSip.Sessions[newSess.ctxid].isMuted = true;
            window.ctxSip.setCallSessionStatus("Muted");
          });

          newSess.on('unmuted', function(e) {
            window.ctxSip.Sessions[newSess.ctxid].isMuted = false;
            window.ctxSip.setCallSessionStatus("Answered");
          });

          newSess.on('cancel', function(e) {
            window.ctxSip.stopRingTone();
            window.ctxSip.stopRingbackTone();
            window.ctxSip.setCallSessionStatus("Canceled");
            if (this.direction === 'outgoing') {
              window.ctxSip.callActiveID = null;
              newSess = null;
              window.ctxSip.logCall(this, 'ended');
            }
          });

          newSess.on('bye', function(e) {
            window.ctxSip.stopRingTone();
            window.ctxSip.stopRingbackTone();
            window.ctxSip.setCallSessionStatus("");
            window.ctxSip.logCall(newSess, 'ended');
            window.ctxSip.callActiveID = null;

            setActiveSession(null);
            setIsCallActive(false);
            newSess = null;
          });

          newSess.on('failed', function(e) {
            window.ctxSip.stopRingTone();
            window.ctxSip.stopRingbackTone();
            window.ctxSip.setCallSessionStatus('Terminated');

            setActiveSession(null);
            setIsCallActive(false);
          });

          newSess.on('rejected', function(e) {
            window.ctxSip.stopRingTone();
            window.ctxSip.stopRingbackTone();
            window.ctxSip.setCallSessionStatus('Rejected');
            window.ctxSip.callActiveID = null;

            setActiveSession(null);
            setIsCallActive(false);
            newSess = null;
          });

          window.ctxSip.Sessions[newSess.ctxid] = newSess;
        },

        setCallSessionStatus: function(status) {
          window.$('#txtCallStatus').html(status);
        },

        setStatus: function(status) {
          window.$("#txtRegStatus").html('<i class="fa fa-signal"></i> ' + status);
        },

        logCall: function(session, status) {
          var log = {
            clid: session.displayName,
            uri: session.remoteIdentity.uri.toString(),
            id: session.ctxid,
            time: new Date().getTime()
          },
            calllog = JSON.parse(localStorage.getItem('sipCalls'));

          if (!calllog) { calllog = {}; }

          if (!calllog.hasOwnProperty(session.ctxid)) {
            calllog[log.id] = {
              id: log.id,
              clid: log.clid,
              uri: log.uri,
              start: log.time,
              flow: session.direction
            };
          }

          if (status === 'ended') {
            calllog[log.id].stop = log.time;
          }

          if (status === 'ended' && calllog[log.id].status === 'ringing') {
            calllog[log.id].status = 'missed';
          } else {
            calllog[log.id].status = status;
          }

          localStorage.setItem('sipCalls', JSON.stringify(calllog));
          window.ctxSip.logShow();
        },

        logItem: function(item) {
          var callActive = (item.status !== 'ended' && item.status !== 'missed'),
            callLength = (item.status !== 'ended') ? '<span id="' + item.id + '"></span>' : window.moment.duration(item.stop - item.start).humanize(),
            callClass = '',
            callIcon,
            i;

          switch (item.status) {
            case 'ringing':
              callClass = 'list-group-item-success';
              callIcon = 'fa-bell';
              break;

            case 'missed':
              callClass = 'list-group-item-danger';
              if (item.flow === "incoming") { callIcon = 'fa-chevron-left'; }
              if (item.flow === "outgoing") { callIcon = 'fa-chevron-right'; }
              break;

            case 'holding':
              callClass = 'list-group-item-warning';
              callIcon = 'fa-pause';
              break;

            case 'answered':
            case 'resumed':
              callClass = 'list-group-item-info';
              callIcon = 'fa-phone-square';
              break;

            case 'ended':
              if (item.flow === "incoming") { callIcon = 'fa-chevron-left'; }
              if (item.flow === "outgoing") { callIcon = 'fa-chevron-right'; }
              break;

            default:
              break;
          }

          i = '<div class="list-group-item sip-logitem clearfix ' + callClass + '" data-uri="' + item.uri + '" data-sessionid="' + item.id + '" title="Double Click to Call">';
          i += '<div class="clearfix"><div class="pull-left">';
          i += '<i class="fa fa-fw ' + callIcon + ' fa-fw"></i> <small>' + window.moment(item.start).format('MM/DD hh:mm:ss a') + '</small>';
          i += '</div>';
          i += '<div class="pull-left text-left"><br>' + callLength + '</div></div>';

          if (callActive) {
            i += '<div class="btn-group btn-group-xs pull-right">';
            if (item.status === 'ringing' && item.flow === 'incoming') {
              i += '<button class="btn btn-xs btn-success btnCall" title="Call"><i class="fa fa-phone"></i></button>';
            } else {
              i += '<button class="btn btn-xs btn-primary btnHoldResume" title="Hold"><i class="fa fa-pause"></i></button>';
              i += '<button class="btn btn-xs btn-info btnTransfer" title="Transfer"><i class="fa fa-random"></i></button>';
              i += '<button class="btn btn-xs btn-warning  btnMute" title="Mute"><i class="fa fa-fw fa-microphone"></i></button>';
            }
            i += '<button class="btn btn-xs btn-danger btnHangUp" title="Hangup"><i class="fa fa-stop"></i></button>';
            i += '</div>';
          }
          i += '</div>';

          window.$('#sip-logitems').append(i);

          if (item.status === 'answered') {
            var tEle = document.getElementById(item.id);
            if (tEle) {
              window.ctxSip.callTimers[item.id] = new Stopwatch(tEle);
              window.ctxSip.callTimers[item.id].start();
            }
          }

          if (callActive && item.status !== 'ringing' && window.ctxSip.callTimers[item.id]) {
            window.ctxSip.callTimers[item.id].start({ startTime: item.start });
          }

          window.$('#sip-logitems').scrollTop(0);
        },

        logShow: function() {
          var calllog = JSON.parse(localStorage.getItem('sipCalls')),
            x = [];

          if (calllog !== null) {
            window.$('#sip-splash').addClass('hide');
            window.$('#sip-log').removeClass('hide');

            window.$('#sip-logitems').empty();

            window.$.each(calllog, function(k, v) {
              x.push(v);
            });

            x.sort(function(a, b) {
              return b.start - a.start;
            });

            x = x.slice(0, 15);

            window.$.each(x, function(k, v) {
              window.ctxSip.logItem(v);
            });

          } else {
            window.$('#sip-splash').removeClass('hide');
            window.$('#sip-log').addClass('hide');
          }
        },

        logClear: function() {
          localStorage.removeItem('sipCalls');
          window.ctxSip.logShow();
        },

        sipCall: function(target) {
          try {
            var outgoingSession = window.ctxSip.phone.invite(target, {
              sessionDescriptionHandlerOptions: {
                constraints: { audio: true, video: false }
              }
            });
            outgoingSession.direction = 'outgoing';
            window.ctxSip.newSession(outgoingSession);

          } catch (e) {
            throw (e);
          }
        },

        sipHangUp: function(sessionid) {
          var s = window.ctxSip.Sessions[sessionid];
          if (!s) {
            return;
          } else if (s.startTime) {
            s.bye();
          } else if (s.reject) {
            s.reject();
          } else if (s.cancel) {
            s.cancel();
          }
        },

        sipSendDTMF: function(digit) {
          try { window.ctxSip.dtmfTone.play(); } catch (e) { }

          var a = window.ctxSip.callActiveID;
          if (a) {
            var s = window.ctxSip.Sessions[a];
            s.dtmf(digit);
          }
        },

        phoneCallButtonPressed: function(sessionid) {
          var s = window.ctxSip.Sessions[sessionid];

          if (!s) {
            window.$("#numDisplay").val("");
            // Transform pbxusername: replace prefix "45" with "55"
            const numberToCall = contactData.pbxusername.startsWith('45')
              ? '55' + contactData.pbxusername.substring(2)
              : contactData.pbxusername;
            window.ctxSip.sipCall(numberToCall);
          } else if (s.accept && !s.startTime) {
            s.accept({
              sessionDescriptionHandlerOptions: {
                constraints: { audio: true, video: false }
              }
            });
          }
        },

        phoneMuteButtonPressed: function(sessionid) {
          var s = window.ctxSip.Sessions[sessionid];

          if (!s.isMuted) {
            s.mute();
          } else {
            s.unmute();
          }
        },

        phoneHoldButtonPressed: function(sessionid) {
          var s = window.ctxSip.Sessions[sessionid];
          var direction = s.sessionDescriptionHandler.getDirection();

          if (direction === 'sendrecv') {
            s.hold();
          } else {
            s.unhold();
          }
        },

        setError: function(err, title, msg, closable) {
          if (err === true) {
            window.$("#mdlError p").html(msg);
            window.$("#mdlError").modal('show');

            if (closable) {
              var b = '<button type="button" class="close" data-dismiss="modal">&times;</button>';
              window.$("#mdlError .modal-header").find('button').remove();
              window.$("#mdlError .modal-header").prepend(b);
              window.$("#mdlError .modal-title").html(title);
              window.$("#mdlError").modal({ keyboard: true });
            } else {
              window.$("#mdlError .modal-header").find('button').remove();
              window.$("#mdlError .modal-title").html(title);
              window.$("#mdlError").modal({ keyboard: false });
            }
          } else {
            window.$('#numDisplay').removeProp('disabled');
            window.$("#mdlError").modal('hide');
          }
        },

        hasWebRTC: function() {
          if (navigator.webkitGetUserMedia) {
            return true;
          } else if (navigator.mozGetUserMedia) {
            return true;
          } else if (navigator.getUserMedia) {
            return true;
          } else {
            return true;
          }
        }
      };

      const ctxSip = window.ctxSip;

      if (!ctxSip.hasWebRTC()) {
        return true;
      }

      ctxSip.phone = new window.SIP.UA(ctxSip.config);

      ctxSip.phone.on('connected', function(e) {
        ctxSip.setStatus("Connected");
        ctxSip.setError(false)
      });

      ctxSip.phone.on('disconnected', function(e) {
        ctxSip.setStatus("Disconnected");
        ctxSip.setError(true, 'Websocket Disconnected.', 'An Error occurred connecting to the websocket.');
      });

      ctxSip.phone.on('registered', function(e) {
        ctxSip.setError(false)
        var closeEditorWarning = function() {
          return 'If you close this window, you will not be able to make or receive calls from your browser.';
        };

        var closePhone = function() {
          localStorage.removeItem('ctxPhone');
          ctxSip.phone.stop();
        };

        window.onbeforeunload = closeEditorWarning;
        window.onunload = closePhone;

        localStorage.setItem('ctxPhone', 'true');
        window.$("#mldError").modal('hide');
        ctxSip.setStatus("Online");
      });

      ctxSip.phone.on('registrationFailed', function(e) {
        console.log(e)
        ctxSip.setError(true, 'Registration Error.', 'An Error occurred registering your phone. Check your settings.');
        ctxSip.setStatus("Error: Registration Failed");
      });

      ctxSip.phone.on('unregistered', function(e) {
        ctxSip.setError(true, 'Registration Error.', 'An Error occurred registering your phone. Please wait while we try to connect it again.');
        ctxSip.setStatus("Error: Registration Failed");
      });

      ctxSip.phone.on('invite', function(incomingSession) {
        var s = incomingSession;
        s.direction = 'incoming';
        ctxSip.newSession(s);
      });

      window.$('#phoneIcon').click(function(event) {
        event.preventDefault();
        ctxSip.phoneCallButtonPressed();
      });

      window.$('.digit').click(function(event) {
        event.preventDefault();
        var num = window.$('#numDisplay').val(),
          dig = window.$(this).data('digit');

        window.$('#numDisplay').val(num + dig);
        ctxSip.sipSendDTMF(dig);
        return false;
      });

      window.$('#phoneUI').delegate('.btnCall', 'click', function(event) {
        ctxSip.phoneCallButtonPressed();
        return true;
      });

      window.$('.sipLogClear').click(function(event) {
        event.preventDefault();
        ctxSip.logClear();
      });

      window.$('#sip-logitems').delegate('.sip-logitem .btnCall', 'click', function(event) {
        var sessionid = window.$(this).closest('.sip-logitem').data('sessionid');
        ctxSip.phoneCallButtonPressed(sessionid);
        return false;
      });

      window.$('#sip-logitems').delegate('.sip-logitem .btnHoldResume', 'click', function(event) {
        var sessionid = window.$(this).closest('.sip-logitem').data('sessionid');
        ctxSip.phoneHoldButtonPressed(sessionid);
        return false;
      });

      window.$('#sip-logitems').delegate('.sip-logitem .btnHangUp', 'click', function(event) {
        var sessionid = window.$(this).closest('.sip-logitem').data('sessionid');
        ctxSip.sipHangUp(sessionid);
        return false;
      });

      window.$('#sip-logitems').delegate('.sip-logitem .btnMute', 'click', function(event) {
        var sessionid = window.$(this).closest('.sip-logitem').data('sessionid');
        ctxSip.phoneMuteButtonPressed(sessionid);
        return false;
      });

      window.$('#sldVolume').on('change', function() {
        var v = window.$(this).val() / 100,
          btn = window.$('#btnVol'),
          icon = window.$('#btnVol').find('i'),
          active = ctxSip.callActiveID;

        if (ctxSip.Sessions[active]) {
          ctxSip.Sessions[active].player.volume = v;
          ctxSip.callVolume = v;
        }

        window.$('audio').each(function() {
          window.$(this).get()[0].volume = v;
        });

        if (v < 0.1) {
          btn.removeClass(function(index, css) {
            return (css.match(/(^|\s)btn\S+/g) || []).join(' ');
          })
            .addClass('btn btn-sm btn-danger');
          icon.removeClass().addClass('fa fa-fw fa-volume-off');
        } else if (v < 0.8) {
          btn.removeClass(function(index, css) {
            return (css.match(/(^|\s)btn\S+/g) || []).join(' ');
          }).addClass('btn btn-sm btn-info');
          icon.removeClass().addClass('fa fa-fw fa-volume-down');
        } else {
          btn.removeClass(function(index, css) {
            return (css.match(/(^|\s)btn\S+/g) || []).join(' ');
          }).addClass('btn btn-sm btn-primary');
          icon.removeClass().addClass('fa fa-fw fa-volume-up');
        }
        return false;
      });

      setTimeout(function() {
        ctxSip.logShow();
      }, 3000);

      var Stopwatch = function(elem, options) {
        function createTimer() {
          return document.createElement("span");
        }

        var timer = createTimer(),
          offset,
          clock,
          interval;

        options = options || {};
        options.delay = options.delay || 1000;
        options.startTime = options.startTime || Date.now();

        if (elem) {
          elem.appendChild(timer);
        }

        function start() {
          if (!interval) {
            offset = options.startTime;
            interval = setInterval(update, options.delay);
          }
        }

        function stop() {
          if (interval) {
            clearInterval(interval);
            interval = null;
          }
        }

        function reset() {
          clock = 0;
          render();
        }

        function update() {
          clock += delta();
          render();
        }

        function render() {
          timer.innerHTML = window.moment(clock).format('mm:ss');
        }

        function delta() {
          var now = Date.now(),
            d = now - offset;

          offset = now;
          return d;
        }

        reset();

        this.start = start;
        this.stop = stop;
      };
    });
  }, [contactData]);

  if (loading) {
    return (
      <div className="App" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
        <h2>Loading shared contact...</h2>
      </div>
    );
  }

  if (error) {
    return (
      <div className="App" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
        <div style={{ textAlign: 'center' }}>
          <h2>Error</h2>
          <p>{error}</p>
        </div>
      </div>
    );
  }

  return (
    <div className="App">
      <div className="container-fluid">
        <div style={{
          padding: '30px',
          background: 'linear-gradient(135deg, #1a1f2e 0%, #0f1419 100%)',
          borderRadius: '16px',
          marginBottom: '30px',
          boxShadow: '0 10px 30px rgba(255, 153, 0, 0.3)',
          border: '1px solid rgba(255, 153, 0, 0.2)',
          color: '#fff'
        }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '15px', marginBottom: '20px' }}>
            <div style={{
              width: '60px',
              height: '60px',
              borderRadius: '50%',
              background: 'rgba(255, 255, 255, 0.2)',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              fontSize: '24px',
              fontWeight: 'bold',
              backdropFilter: 'blur(10px)'
            }}>
              {contactData.name.charAt(0).toUpperCase()}
            </div>
            <div style={{ flex: 1 }}>
              <h2 style={{
                color: '#fff',
                margin: '0 0 8px 0',
                fontSize: '28px',
                fontWeight: '600',
                letterSpacing: '-0.5px'
              }}>
                {contactData.name}
              </h2>
              <div style={{
                display: 'flex',
                gap: '20px',
                flexWrap: 'wrap',
                fontSize: '15px'
              }}>
                <div style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '8px',
                  background: 'rgba(255, 255, 255, 0.15)',
                  padding: '6px 12px',
                  borderRadius: '8px',
                  backdropFilter: 'blur(10px)'
                }}>
                  <i className="fa fa-phone" style={{ opacity: 0.9 }}></i>
                  <span style={{ fontWeight: '500' }}>{contactData.phone_number}</span>
                </div>
                {contactData.email && (
                  <div style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '8px',
                    background: 'rgba(255, 255, 255, 0.15)',
                    padding: '6px 12px',
                    borderRadius: '8px',
                    backdropFilter: 'blur(10px)'
                  }}>
                    <i className="fa fa-envelope" style={{ opacity: 0.9 }}></i>
                    <span style={{ fontWeight: '500' }}>{contactData.email}</span>
                  </div>
                )}
              </div>
            </div>
          </div>
          <div style={{
            padding: '12px 16px',
            background: 'rgba(255, 255, 255, 0.1)',
            borderRadius: '10px',
            fontSize: '14px',
            borderLeft: '4px solid rgba(255, 255, 255, 0.4)',
            backdropFilter: 'blur(10px)'
          }}>
            <i className="fa fa-info-circle" style={{ marginRight: '8px', opacity: 0.9 }}></i>
            <span style={{ opacity: 0.95 }}>Click the "Call" button below to start a call</span>
          </div>
        </div>

        <div className="clearfix sipStatus">
          <div id="txtCallStatus" className="pull-right">&nbsp;</div>
          <div id="txtRegStatus"></div>
        </div>

        {isCallActive && activeSession && (
          <div className="call-controls-wrapper">
            <div className="call-controls">
              <button
                className="call-btn hangup"
                onClick={() => {
                  activeSession.bye?.();
                  setIsCallActive(false);
                  setActiveSession(null);
                }}
              >
                <i className="fa fa-phone-slash"></i> Hang Up
              </button>

              <button
                className="call-btn hold"
                onClick={() => {
                  const direction = activeSession.sessionDescriptionHandler.getDirection();
                  if (direction === 'sendrecv') {
                    activeSession.hold();
                  } else {
                    activeSession.unhold();
                  }
                }}
              >
                <i className="fa fa-pause"></i> Hold / Resume
              </button>

              <button
                className="call-btn mute"
                onClick={() => {
                  if (activeSession.isMuted) {
                    activeSession.unmute();
                  } else {
                    activeSession.mute();
                  }
                }}
              >
                <i className="fa fa-microphone-slash"></i> Mute / Unmute
              </button>
            </div>
          </div>
        )}

        {!isCallActive && activeSession && activeSession.direction === 'incoming' && (
          <div className="call-controls-wrapper">
            <div className="call-controls">
              <button
                className="call-btn answer"
                style={{
                  backgroundColor: '#4CAF50',
                  color: 'white',
                  border: 'none',
                  padding: '10px 20px',
                  borderRadius: '5px',
                  margin: '0 5px',
                  cursor: 'pointer',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '8px'
                }}
                onClick={() => {
                  if (window.ctxSip && activeSession && activeSession.ctxid) {
                    window.ctxSip.phoneCallButtonPressed(activeSession.ctxid);
                    setIsCallActive(true);
                  } else {
                    console.error("Unable to accept call: ctxSip or ctxid missing");
                  }
                }}
              >
                <i className="fa fa-phone"></i> Answer
              </button>

              <button
                className="call-btn reject"
                style={{
                  backgroundColor: '#f44336',
                  color: 'white',
                  border: 'none',
                  padding: '10px 20px',
                  borderRadius: '5px',
                  margin: '0 5px',
                  cursor: 'pointer',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '8px'
                }}
                onClick={() => {
                  activeSession.reject();
                  setActiveSession(null);
                }}
              >
                <i className="fa fa-phone-slash"></i> Reject
              </button>
            </div>
          </div>
        )}

        <div className="form-group" id="phoneUI">
          <div className="input-group">
            <div className="text-center w-100">
              <button className="btn btn-success btn-block btnCall" title="Send" style={{ width: '150px' }}>
                <i className="fa fa-phone"></i> Call
              </button>
            </div>

            <div className="input-group-btn input-group-btn-sm">
              <button
                className="btn btn-sm btn-primary dropdown-toggle"
                id="btnVol"
                data-toggle="dropdown"
                title="Volume"
              >
                <i className="fa fa-fw fa-volume-up"></i>
              </button>
              <div className="dropdown-menu">
                <input
                  type="range"
                  min="0"
                  max="100"
                  defaultValue="100"
                  step="1"
                  id="sldVolume"
                />
              </div>
            </div>
          </div>
        </div>

        <div className="well-sip">
          <div>
            <video id="localVideo" hidden muted autoPlay width="300" height="240" ref={videoRef}></video>
          </div>

          <div>
            <div className="sip-video-container">
              <video
                id="remoteVideo"
                autoPlay
                className="sip-video-remote"
                style={{ transform: `rotate(${rotation}deg)`, transition: 'transform 0.3s ease' }}
                ref={videoRef}
              ></video>
            </div>

            <div className="zoom-controls">
              <button onClick={handleRotate}>
                <FiRotateCw />
                Rotate
              </button>
              <button className="zoom-button" onClick={() => handleZoom(-0.1)}>
                − Zoom Out
              </button>
              <button className="zoom-button" onClick={() => handleZoom(0.1)}>
                + Zoom In
              </button>
            </div>
          </div>

          <div id="sip-log" className="panel panel-default hide">
            <div className="panel-heading">
              <h4 className="text-muted panel-title">Recent Calls <span className="pull-right"><i className="fa fa-trash text-muted sipLogClear" title="Clear Log"></i></span></h4>
            </div>
            <div id="sip-logitems" className="list-group">
              <p className="text-muted text-center">No recent calls from this browser.</p>
            </div>
          </div>
        </div>

        <div className="modal fade" id="mdlError" tabIndex="-1" role="dialog" aria-hidden="true" data-backdrop="static" data-keyboard="false">
          <div className="modal-dialog modal-sm">
            <div className="modal-content">
              <div className="modal-header">
                <h4 className="modal-title">Sip Error</h4>
              </div>
              <div className="modal-body text-center text-danger">
                <h3><i className="fa fa-3x fa-ban"></i></h3>
                <p className="lead">Sip registration failed. No calls can be handled.</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <audio id="ringtone" src="/sounds/incoming.mp3" loop></audio>
      <audio id="ringbacktone" src="/sounds/outgoing.mp3" loop></audio>
      <audio id="dtmfTone" src="/sounds/dtmf.mp3"></audio>
      <audio id="audioRemote"></audio>
    </div>
  );
}

export default SharedCallPage;
